import { useAuth } from "../context/AuthContext";
import { UserRoles, UserStatus } from "../types/user.types";
import { RegisteredUserDashboardHome } from "../components/user-activation-reminder";
import { PrimaryUserHome } from "./home/primary-user-home";

export interface IHomeProps {}

export default function Home(props: IHomeProps) {
  const { user } = useAuth();

  if (!user) {
    return null;
  }


  if (
    user.status === UserStatus.REGISTERED &&
    user.roleId === UserRoles.INVITED_USER
  ) {
    return <RegisteredUserDashboardHome />;
  }

  switch (user.roleId) {
    case UserRoles.SYSTEM_ADMIN:
      return null;
    case UserRoles.CLIENT_ADMIN:
      return null;
    case UserRoles.PRIMARY_USER:
      return <PrimaryUserHome />;

    case UserRoles.INVITED_USER:
      return null;
    default:
      return null;
  }
}
